// extracted by mini-css-extract-plugin
export default {"cls1":"hOHZ11c4Tq95_Gacr11w","cls2":"i0Vc5jITHr1c1GsFHFhl hOHZ11c4Tq95_Gacr11w"};